import React, { Component } from "react";
import axios from "axios";
import FeatherIcon from "feather-icons-react";
import Design from "../components/Design";
import Support from "../components/Support";
import Intervenant from "../components/Intervenant";
import Design3 from "../components/Design3";
import Design4 from "../components/Design4";
import Navbar from "../partials/Navbar";
import Design7 from "../components/Design7";
import Design8 from "../components/Design8";
import Login from "../components/Login";
import SchoolStoriesSlider from "../components/SchoolStoriesSlider";
// import AIAssistant from "../components/AIAssistant";
import "../assets/css/parent-portal.css";
import "../assets/css/search-bar.css";

class Dashboard extends Component {
  state = {
    loading: true,
    error: "",
    activeTab: "dashboard",
    parent: null,
    links: [],
    students: [],
    studentDetails: {},
    notificationsCount: 0,
    isAuthenticated: false,
  };

  componentDidMount() {
    this.bootstrapPortal();
  }

  bootstrapPortal = async () => {
    this.setState({ loading: true, error: "" });
    try {
      const token = await axios.get("token");
      if (token.status !== 200 || !token.data?.data) {
        throw new Error("Session invalide");
      }

      const parent = token.data.data;
      localStorage.setItem("user", JSON.stringify(parent));

      const [linksRes, usersRes, notificationsRes] = await Promise.allSettled([
        axios.get("/links"),
        axios.get("/user"),
        axios.get("/notifications"),
      ]);

      const rawLinks = linksRes.status === "fulfilled" && linksRes.value.status === 200 ? linksRes.value.data || [] : [];
      const links = Array.from(new Map(rawLinks.map((link) => [link.title?.toLowerCase().trim() || link.id, link])).values());
      const users = usersRes.status === "fulfilled" && usersRes.value.status === 200 ? usersRes.value.data || [] : [];
      const notifications = notificationsRes.status === "fulfilled" && notificationsRes.value.status === 200 ? notificationsRes.value.data || [] : [];
      const notificationsCount = this.countUnreadNotifications(notifications);

      const studentRefs = users.filter((entry) => entry && entry.userId);
      const studentResponses = await Promise.allSettled(
        studentRefs.map((entry) => axios.get(`userapi/${encodeURIComponent(entry.id)}`))
      );

      const students = studentResponses
        .filter((result) => result.status === "fulfilled" && result.value.status === 200)
        .map((result) => result.value.data)
        .filter(Boolean);

      const studentDetails = await this.loadAllStudentDetails(students);

      this.setState({
        loading: false,
        isAuthenticated: true,
        activeTab: "dashboard",
        parent,
        links,
        students,
        studentDetails,
        notificationsCount,
      });
    } catch (error) {
      window.localStorage.removeItem("user");
      this.setState({
        loading: false,
        isAuthenticated: false,
        activeTab: "dashboard",
        error: "",
      });
    }
  };

  loadAllStudentDetails = async (students) => {
    const detailEntries = await Promise.all(
      students.map(async (student) => {
        const [feesRes, disciplinesRes, reportcardsRes] = await Promise.allSettled([
          axios.get(`/schoolfees/${student.id}`),
          axios.get(`disciplines/${student.id}`),
          axios.get(`/reportcards/${student.id}`),
        ]);

        const fees =
          feesRes.status === "fulfilled" && feesRes.value.status === 200 && feesRes.value.data?.schoolfees
            ? this.sortByCreatedAtDesc(feesRes.value.data.schoolfees)
            : [];
        const disciplines =
          disciplinesRes.status === "fulfilled" && disciplinesRes.value.status === 200
            ? this.sortByCreatedAtDesc(disciplinesRes.value.data || [])
            : [];
        const reportcards =
          reportcardsRes.status === "fulfilled" && reportcardsRes.value.status === 200
            ? reportcardsRes.value.data?.reportcards || []
            : [];

        return [
          String(student.id),
          {
            fees,
            disciplines,
            reportcards: this.normalizeReportcards(reportcards),
          },
        ];
      })
    );

    return Object.fromEntries(detailEntries);
  };

  normalizeReportcards = (reportcards) =>
    reportcards.flatMap((reportcard) =>
      (reportcard?.notes || []).map((note, index) => ({
        id: `${reportcard?.id || "report"}-${note?.id || index}`,
        lesson:
          reportcard?.sectionclasselesson?.lesson?.entitled_lesson ||
          reportcard?.sectionclasselesson?.lesson?.short_entitled_lesson ||
          "Matière",
        teacher: reportcard?.sectionclasselesson?.staff
          ? `${reportcard.sectionclasselesson.staff.user?.first_name || ""} ${reportcard.sectionclasselesson.staff.user?.last_name || ""}`.trim()
          : "-",
        period:
          reportcard?.periode?.title ||
          reportcard?.periode?.periode ||
          (reportcard?.periode?.id ? `${reportcard.periode.id}e période` : "Période"),
        periodOrder: Number(reportcard?.periode?.id || 999),
        note: note?.note || 0,
        max: note?.evaluation?.max || 0,
        createdAt: note?.createdAt || reportcard?.createdAt,
      }))
    );

  sortByCreatedAtDesc = (items) =>
    [...items].sort((a, b) => {
      const dateA = new Date(a?.createdAt || 0).getTime();
      const dateB = new Date(b?.createdAt || 0).getTime();
      return dateB - dateA;
    });

  countUnreadNotifications = (notifications) => {
    const seen = {};
    let unread = 0;
    notifications.forEach((box) => {
      if (!box || seen[box.id]) {
        return;
      }
      seen[box.id] = true;
      if (!box.userchats?.readAt) {
        unread += 1;
      }
    });
    return unread;
  };

  handleLogout = async (redirect = true) => {
    try {
      await axios.post("logout");
    } catch (error) {
      // Déconnexion locale même si l'API échoue.
    }
    window.localStorage.clear();
    if (redirect) {
      window.location.replace(process.env.REACT_APP_EVIVESOMA);
    }
  };

  setTab = (activeTab) => {
    if (!this.state.isAuthenticated && activeTab !== "dashboard") {
      this.openLoginPrompt();
      return;
    }
    this.setState({ activeTab });
  };

  openLoginPrompt = () => {
    const modal = document.getElementById("popupLogin");
    if (!modal) {
      window.location.hash = "popupLogin";
      return;
    }

    window.location.hash = "popupLogin";
    modal.scrollIntoView({ behavior: "smooth", block: "center" });

    if (window.bootstrap?.Modal) {
      const loginModal =
        typeof window.bootstrap.Modal.getOrCreateInstance === "function"
          ? window.bootstrap.Modal.getOrCreateInstance(modal)
          : new window.bootstrap.Modal(modal);
      loginModal.show();
      window.setTimeout(() => document.getElementById("yourUsername")?.focus(), 250);
      return;
    }

    const existingBackdrop = document.querySelector("[data-login-modal-backdrop]");
    if (!existingBackdrop) {
      const backdrop = document.createElement("div");
      backdrop.className = "modal-backdrop fade show";
      backdrop.setAttribute("data-login-modal-backdrop", "true");
      document.body.appendChild(backdrop);
    }

    document.body.classList.add("modal-open");
    modal.classList.add("show");
    modal.style.display = "block";
    modal.setAttribute("aria-modal", "true");
    modal.removeAttribute("aria-hidden");
    window.setTimeout(() => document.getElementById("yourUsername")?.focus(), 250);
  };

  formatDate = (dateString) => (dateString ? new Date(dateString).toLocaleDateString("fr-FR") : "-");

  fullName = (user) => [user?.first_name, user?.last_name, user?.family_name].filter(Boolean).join(" ");

  getStudentClass = (student) =>
    student?.sectionclass
      ? `${student.sectionclass.class?.short_entitled_class || ""} ${student.sectionclass.title || ""}`.trim()
      : "-";

  groupReportcardsByPeriod = (reportcards) => {
    const grouped = reportcards.reduce((acc, row) => {
      const period = row.period || "Période";
      if (!acc[period]) {
        acc[period] = { title: period, order: row.periodOrder || 999, rows: [] };
      }
      acc[period].rows.push(row);
      return acc;
    }, {});

    return Object.values(grouped)
      .sort((a, b) => a.order - b.order || a.title.localeCompare(b.title))
      .map((group) => ({
        ...group,
        rows: group.rows.sort((a, b) => a.lesson.localeCompare(b.lesson)),
      }));
  };

  getFeeMeta = (fee) => {
    const category = fee?.sectionschoolfeecategory?.schoolfeecategory?.category || "Frais scolaire";
    const currency = fee?.sectionschoolfeecategory?.currency || "";
    const payAmount = Number(fee?.pay_mount || 0);
    const remainingAmount = Number(fee?.remaining_amount || 0);
    const totalAmount = payAmount + remainingAmount;
    const progress = totalAmount > 0 ? Math.min(100, Math.round((payAmount / totalAmount) * 100)) : remainingAmount === 0 ? 100 : 0;
    const period =
      fee?.trimesectschool?.trimester?.short_trimester ||
      fee?.trimesectschool?.trimester?.trimester ||
      fee?.month?.month ||
      "-";

    return { category, currency, payAmount, remainingAmount, progress, period };
  };

  renderTopbar() {
    const { notificationsCount } = this.state;
    return (
      <header className="parent-topbar">
        <div className="container parent-container px-3 d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center gap-3">
            <div className="brand-mark">
              <img src="/logo192.png" alt="EviveSoma" width="32" height="32" />
            </div>
            <div>
              <h1>EviveSoma</h1>
              <p className="mb-0 small">Espace parent</p>
            </div>
          </div>
          <button type="button" className="icon-button position-relative" aria-label="Notifications">
            <FeatherIcon icon="bell" size={20} />
            {notificationsCount > 0 ? (
              <span className="notification-dot">{notificationsCount > 9 ? "+9" : notificationsCount}</span>
            ) : null}
          </button>
        </div>
      </header>
    );
  }

  renderLoadingState() {
    return (
      <section className="parent-card loading-card animate-in">
        <div className="card-body p-4">
          <span className="eyebrow">Chargement</span>
          <h2 className="h5 fw-bold mb-2">Préparation du tableau de bord</h2>
          <p className="small mb-4">Nous récupérons les écoles, les enfants, les paiements et les notes.</p>
          <div className="portal-skeleton large" />
          <div className="portal-skeleton" />
          <div className="portal-skeleton short" />
        </div>
      </section>
    );
  }

  renderErrorState() {
    return (
      <section className="parent-card animate-in text-center">
        <div className="card-body p-5">
          <div className="empty-icon mb-3">
            <FeatherIcon icon="cloud-off" size={30} />
          </div>
          <h2 className="h5 fw-bold">Connexion impossible</h2>
          <p className="small mb-4">{this.state.error || "Une erreur est survenue lors du chargement des données."}</p>
          <button type="button" className="btn btn-primary rounded-pill px-4 fw-bold" onClick={this.bootstrapPortal}>
            Réessayer
          </button>
        </div>
      </section>
    );
  }

  renderDashboardTab() {
    const { parent, students, links, studentDetails, notificationsCount } = this.state;
    const details = Object.values(studentDetails);
    const totalFees = details.reduce((sum, detail) => sum + detail.fees.length, 0);
    const totalNotes = details.reduce((sum, detail) => sum + detail.reportcards.length, 0);
    const totalIncidents = details.reduce((sum, detail) => sum + detail.disciplines.length, 0);
    const pendingFees = details.reduce(
      (sum, detail) => sum + detail.fees.filter((fee) => Number(fee?.remaining_amount || 0) > 0).length,
      0
    );
    const latestNotes = details
      .flatMap((detail) => detail.reportcards)
      .sort((a, b) => new Date(b?.createdAt || 0).getTime() - new Date(a?.createdAt || 0).getTime())
      .slice(0, 3);
    const latestFees = details
      .flatMap((detail) => detail.fees)
      .sort((a, b) => new Date(b?.createdAt || 0).getTime() - new Date(a?.createdAt || 0).getTime())
      .slice(0, 3);
    const latestDiscipline = details
      .flatMap((detail) => detail.disciplines)
      .sort((a, b) => new Date(b?.createdAt || 0).getTime() - new Date(a?.createdAt || 0).getTime())
      .slice(0, 2);

    return (
      <div className="animate-in connected-home-landing">
        <div className="dashboard-overview">
          <section className="dashboard-welcome-panel">
            <div className="dashboard-welcome-copy">
              <span className="eyebrow">Tableau de bord</span>
              <h2>Bonjour {parent?.name || "cher parent"}</h2>
              <p>Suivez les enfants, les ecoles, les paiements et les notes depuis un espace plus clair.</p>
              <div className="dashboard-quick-actions">
                <button type="button" onClick={() => this.setTab("children")}>
                  <FeatherIcon icon="users" size={18} />
                  Voir les enfants
                </button>
                <button type="button" onClick={() => this.setTab("profile")}>
                  <FeatherIcon icon="user" size={18} />
                  Mon profil
                </button>
              </div>
            </div>
            <div className="dashboard-focus-card">
              <span className="dashboard-focus-label">Resume</span>
              <strong>{students.length}</strong>
              <p>{students.length > 1 ? "enfants suivis" : "enfant suivi"}</p>
              <div>
                <span>{links.length} ecoles</span>
                <span>{notificationsCount} notifications</span>
              </div>
            </div>
          </section>

          <section className="dashboard-stat-grid" aria-label="Indicateurs principaux">
            <article className="dashboard-stat-card">
              <FeatherIcon icon="users" size={20} />
              <strong>{students.length}</strong>
              <span>Enfants</span>
            </article>
            <article className="dashboard-stat-card">
              <FeatherIcon icon="home" size={20} />
              <strong>{links.length}</strong>
              <span>Ecoles</span>
            </article>
            <article className="dashboard-stat-card">
              <FeatherIcon icon="award" size={20} />
              <strong>{totalNotes}</strong>
              <span>Notes</span>
            </article>
            <article className="dashboard-stat-card warning">
              <FeatherIcon icon="credit-card" size={20} />
              <strong>{pendingFees}</strong>
              <span>Frais a solder</span>
            </article>
          </section>

          <div className="dashboard-main-grid">
            <section className="dashboard-panel">
              <div className="dashboard-panel-heading">
                <div>
                  <span className="eyebrow">Enfants</span>
                  <h3>Apercu familial</h3>
                </div>
                <button type="button" onClick={() => this.setTab("children")} aria-label="Ouvrir la page enfants">
                  <FeatherIcon icon="arrow-right" size={18} />
                </button>
              </div>
              <div className="dashboard-child-list">
                {students.slice(0, 3).map((student) => {
                  const details = studentDetails[String(student.id)] || { fees: [], disciplines: [], reportcards: [] };
                  return (
                    <article key={student.id} className="dashboard-child-card">
                      <img src={student?.user?.avatar || "/logo192.png"} alt={this.fullName(student?.user) || "Eleve"} />
                      <div>
                        <h4>{this.fullName(student?.user) || "Eleve"}</h4>
                        <p>{this.getStudentClass(student)}</p>
                      </div>
                      <span>{details.reportcards.length} notes</span>
                    </article>
                  );
                })}
                {!students.length && (
                  <div className="dashboard-empty-state">
                    <FeatherIcon icon="user-x" size={26} />
                    <p>Aucun enfant lie a votre compte.</p>
                  </div>
                )}
              </div>
            </section>

            <section className="dashboard-panel">
              <div className="dashboard-panel-heading">
                <div>
                  <span className="eyebrow">Activite</span>
                  <h3>Derniers elements</h3>
                </div>
                <span className="dashboard-count">{totalFees + totalNotes + totalIncidents}</span>
              </div>
              <div className="dashboard-activity-list">
                {latestNotes.map((row) => (
                  <div key={row.id} className="dashboard-activity-row">
                    <span className="activity-icon note"><FeatherIcon icon="award" size={16} /></span>
                    <div>
                      <strong>{row.lesson}</strong>
                      <p>{row.note}/{row.max} - {row.period}</p>
                    </div>
                  </div>
                ))}
                {latestFees.map((fee) => {
                  const meta = this.getFeeMeta(fee);
                  return (
                    <div key={fee.id} className="dashboard-activity-row">
                      <span className="activity-icon fee"><FeatherIcon icon="credit-card" size={16} /></span>
                      <div>
                        <strong>{meta.category}</strong>
                        <p>{meta.payAmount} {meta.currency} paye - {meta.period}</p>
                      </div>
                    </div>
                  );
                })}
                {latestDiscipline.map((discipline) => (
                  <div key={discipline.id} className="dashboard-activity-row">
                    <span className="activity-icon discipline"><FeatherIcon icon="alert-circle" size={16} /></span>
                    <div>
                      <strong>{discipline.motif || "Incident"}</strong>
                      <p>{this.formatDate(discipline.createdAt)}</p>
                    </div>
                  </div>
                ))}
                {!latestNotes.length && !latestFees.length && !latestDiscipline.length && (
                  <div className="dashboard-empty-state">
                    <FeatherIcon icon="inbox" size={26} />
                    <p>Aucune activite recente.</p>
                  </div>
                )}
              </div>
            </section>
          </div>

          <section className="dashboard-school-strip">
            <div>
              <span className="eyebrow">Ecoles liees</span>
              <h3>Vos etablissements</h3>
            </div>
            <div className="dashboard-school-list">
              {links.slice(0, 4).map((link) => (
                <span key={link.id}><FeatherIcon icon="check-circle" size={16} />{link.title || "Ecole"}</span>
              ))}
              {!links.length && <span><FeatherIcon icon="home" size={16} />Aucune ecole liee</span>}
            </div>
          </section>
        </div>

        <div className="dashboard-public-sections">
          <Design />
          <Support />
          <Intervenant />
          <Design3 />
          <Design4 />
          <SchoolStoriesSlider />
          <Design7 />
          <Design8 />
        </div>
      </div>
    );
  }

  renderSchoolsSection() {
    const { links } = this.state;
    return (
      <section className="portal-section">
        <div className="section-heading">
          <span className="eyebrow">Écoles</span>
          <h3>Établissements liés</h3>
        </div>
        <div className="school-grid">
          {links.map((link) => (
            <article key={link.id} className="school-card">
              <div className="school-icon">
                <FeatherIcon icon="home" size={22} />
              </div>
              <div>
                <h4>{link.title || "Ecole"}</h4>
                <p>Compte parent actif</p>
              </div>
            </article>
          ))}
          {!links.length && (
            <div className="empty-panel">
              <FeatherIcon icon="home" size={26} />
              <p>Aucune école liée pour le moment.</p>
            </div>
          )}
        </div>
      </section>
    );
  }

  renderChildrenOverview() {
    const { parent, students, links, studentDetails } = this.state;
    const totalFees = Object.values(studentDetails).reduce((sum, detail) => sum + detail.fees.length, 0);
    const totalNotes = Object.values(studentDetails).reduce((sum, detail) => sum + detail.reportcards.length, 0);

    return (
      <>
        <section className="portal-hero">
          <div>
            <span className="eyebrow">Bienvenue</span>
            <h2>{parent?.name || "Cher parent"}</h2>
            <p>Votre suivi scolaire est rassemblé ici, sans parcours compliqué.</p>
          </div>
          <img className="portal-hero-visual" src="/assets/img/hero/hero-img.png" alt="" aria-hidden="true" />
          <div className="hero-orbit">
            <FeatherIcon icon="users" size={34} />
          </div>
        </section>

        <section className="summary-grid">
          <div className="summary-tile">
            <FeatherIcon icon="user-check" size={20} />
            <strong>{students.length}</strong>
            <span>Enfants</span>
          </div>
          <div className="summary-tile">
            <FeatherIcon icon="home" size={20} />
            <strong>{links.length}</strong>
            <span>Écoles</span>
          </div>
          <div className="summary-tile">
            <FeatherIcon icon="award" size={20} />
            <strong>{totalNotes}</strong>
            <span>Notes</span>
          </div>
          <div className="summary-tile">
            <FeatherIcon icon="credit-card" size={20} />
            <strong>{totalFees}</strong>
            <span>Frais</span>
          </div>
        </section>

        {this.renderSchoolsSection()}

        <section className="portal-section">
          <div className="section-heading">
            <span className="eyebrow">Enfants</span>
            <h3>Tableau de bord complet</h3>
            <p>Toutes les informations disponibles s'affichent directement.</p>
          </div>

          <div className="children-stack">
            {students.map((student) => {
              const details = studentDetails[String(student.id)] || { fees: [], disciplines: [], reportcards: [] };
              return this.renderStudentDashboard(student, details);
            })}
            {!students.length && (
              <div className="empty-panel">
                <FeatherIcon icon="user-x" size={30} />
                <p>Aucun enfant trouvé. Veuillez contacter l'administration de l'école.</p>
              </div>
            )}
          </div>
        </section>
      </>
    );
  }

  renderStudentDashboard(student, details) {
    const studentName = this.fullName(student?.user);
    const classe = this.getStudentClass(student);
    const section = student?.sectionclass?.section?.entitled_section || "-";
    const school = student?.establishment?.name || student?.sectionclass?.establishment?.name || "Ecole";
    const periods = this.groupReportcardsByPeriod(details.reportcards);

    return (
      <article key={student.id} className="student-dashboard-card">
        <header className="student-header">
          <div className="student-avatar">
            <img src={student?.user?.avatar || "/logo192.png"} alt={studentName || "Eleve"} />
          </div>
          <div className="student-title">
            <h4>{studentName || "Eleve"}</h4>
            <p>Matricule {student?.matricule || "-"}</p>
          </div>
        </header>

        <div className="info-strip">
          <div>
            <FeatherIcon icon="home" size={16} />
            <span>{school}</span>
          </div>
          <div>
            <FeatherIcon icon="bookmark" size={16} />
            <span>{classe}</span>
          </div>
          <div>
            <FeatherIcon icon="layers" size={16} />
            <span>{section}</span>
          </div>
        </div>

        <div className="student-content-grid">
          <section className="data-panel notes-panel">
            <div className="panel-heading">
              <div>
                <span className="eyebrow">Parcours scolaire</span>
                <h5>Notes par periode</h5>
              </div>
              <span className="count-pill">{details.reportcards.length}</span>
            </div>
            {periods.map((period) => (
              <div key={period.title} className="period-block">
                <h6>{period.title}</h6>
                <div className="notes-list">
                  {period.rows.map((row) => this.renderNoteRow(row))}
                </div>
              </div>
            ))}
            {!periods.length && <p className="empty-copy">Aucune note enregistrée.</p>}
          </section>

          <section className="data-panel">
            <div className="panel-heading">
              <div>
                <span className="eyebrow">Frais scolaires</span>
                <h5>Paiements récents</h5>
              </div>
              <span className="count-pill success">{details.fees.length}</span>
            </div>
            <div className="fees-list">
              {details.fees.map((fee) => this.renderFeeRow(fee))}
              {!details.fees.length && <p className="empty-copy">Aucun paiement enregistré.</p>}
            </div>
          </section>

          <section className="data-panel">
            <div className="panel-heading">
              <div>
                <span className="eyebrow">Discipline</span>
                <h5>Assiduite</h5>
              </div>
              <span className="count-pill danger">{details.disciplines.length}</span>
            </div>
            <div className="discipline-list">
              {details.disciplines.map((discipline) => (
                <div key={discipline.id} className="discipline-row">
                  <strong>{discipline.motif || "Incident"}</strong>
                  <p>{discipline.description || "-"}</p>
                  <span>{this.formatDate(discipline.createdAt)}</span>
                </div>
              ))}
              {!details.disciplines.length && <p className="empty-copy positive">Aucun incident signalé.</p>}
            </div>
          </section>
        </div>
      </article>
    );
  }

  renderNoteRow(row) {
    const note = parseFloat(row.note || 0);
    const max = parseFloat(row.max || 0);
    const isLow = max > 0 && note < max / 2;
    return (
      <div key={row.id} className="note-row">
        <div>
          <strong>{row.lesson}</strong>
          <span>{row.teacher || "-"}</span>
        </div>
        <div className={isLow ? "note-score low" : "note-score"}>
          {row.note}
          <small>/{row.max}</small>
        </div>
      </div>
    );
  }

  renderFeeRow(fee) {
    const meta = this.getFeeMeta(fee);
    const isPaidInFull = meta.remainingAmount === 0;

    return (
      <div key={fee.id} className="fee-row">
        <div className="fee-main">
          <div>
            <strong>{meta.category}</strong>
            <span>Facture {fee?.invoice || "-"} - {meta.period}</span>
          </div>
          <div className="fee-amount">
            <strong>{meta.payAmount} {meta.currency}</strong>
            <span className={isPaidInFull ? "paid" : "pending"}>
              {isPaidInFull ? "Solde" : `Reste ${meta.remainingAmount} ${meta.currency}`}
            </span>
          </div>
        </div>
        <div className="fee-progress">
          <span style={{ width: `${meta.progress}%` }} />
        </div>
        <div className="fee-meta">
          <span>{this.formatDate(fee?.createdAt)}</span>
          <span>{fee?.staff?.user ? `${fee.staff.user.last_name || ""} ${fee.staff.user.first_name || ""}`.trim() : ""}</span>
        </div>
      </div>
    );
  }

  renderProfileTab() {
    const { parent, links } = this.state;
    return (
      <div className="animate-in">
        <section className="portal-hero profile-hero">
          <div>
            <span className="eyebrow">Profil</span>
            <h2>{parent?.name || "Parent"}</h2>
            <p>Vos informations de contact et les établissements liés à votre compte parent.</p>
          </div>
          <img className="portal-hero-visual" src="/assets/img/manager/manager.png" alt="" aria-hidden="true" />
          <div className="hero-orbit">
            <FeatherIcon icon="user" size={34} />
          </div>
        </section>

        <section className="profile-card">
          <div className="student-avatar profile-avatar">
            <img src={parent?.avatar || "/logo192.png"} alt={parent?.name || "Parent"} />
          </div>
          <h2>{parent?.name || "Parent"}</h2>
          <p>Gestion des informations utilisateur</p>
          <div className="profile-fields">
            <div>
              <FeatherIcon icon="mail" size={18} />
              <span>{parent?.email || "Non renseigne"}</span>
            </div>
            <div>
              <FeatherIcon icon="phone" size={18} />
              <span>{parent?.tel || "Non renseigne"}</span>
            </div>
          </div>
        </section>

        <section className="portal-section">
          <div className="section-heading">
            <span className="eyebrow">Compte</span>
            <h3>Établissements partenaires</h3>
          </div>
          <div className="school-grid">
            {links.map((link) => (
              <article key={link.id} className="school-card compact">
                <div>
                  <h4>{link.title || "Ecole"}</h4>
                  <p>Actif</p>
                </div>
                <FeatherIcon icon="check-circle" size={20} />
              </article>
            ))}
            {!links.length && <p className="empty-copy">Aucun établissement lié.</p>}
          </div>
        </section>

        <button type="button" className="logout-button" onClick={() => this.handleLogout()}>
          <FeatherIcon icon="log-out" size={17} />
          Se déconnecter
        </button>
      </div>
    );
  }

  renderBottomNav() {
    const { activeTab, isAuthenticated } = this.state;
    if (!isAuthenticated) {
      return null;
    }

    const tabs = [
      { id: "dashboard", label: "Accueil", icon: "home" },
      { id: "children", label: "Enfants", icon: "users" },
      { id: "profile", label: "Profil", icon: "user" },
    ];
    return (
      <nav className="parent-bottom-nav" aria-label="Navigation principale">
        {tabs.map((tab) => {
          const isLocked = !isAuthenticated && tab.id !== "dashboard";
          return (
            <button
              key={tab.id}
              type="button"
              className={`parent-nav-btn ${activeTab === tab.id ? "active" : ""}`}
              onClick={() => this.setTab(tab.id)}
              aria-label={isLocked ? `${tab.label}, connexion requise` : tab.label}
            >
              <FeatherIcon icon={tab.icon} size={22} />
              <span>{tab.label}</span>
            </button>
          );
        })}
      </nav>
    );
  }

  renderActiveTab() {
    const { activeTab } = this.state;
    if (activeTab === "profile") {
      return this.renderProfileTab();
    }
    if (activeTab === "children") {
      return <div className="animate-in">{this.renderChildrenOverview()}</div>;
    }
    return this.renderDashboardTab();
  }

  render() {
    const { loading, error, isAuthenticated, activeTab } = this.state;
    const contentClassName =
      !loading && !error && activeTab === "dashboard"
        ? "parent-content connected-home-content"
        : "container parent-container py-3 parent-content";

    if (!isAuthenticated && !loading) {
      return (
        <main className="main public-home-with-nav" id="top">
          <Navbar />
          <div>
            <Design />
            <Support />
            <Intervenant />
            <Design3 />
            <Design4 />
            <SchoolStoriesSlider />
          </div>
          <Design7 />
          <Design8 />
          {/* <AIAssistant isAuthenticated={false} activeTab="public" /> */}
          <Login />
        </main>
      );
    }

    return (
      <main className="main parent-portal">
        {this.renderTopbar()}
        <section className={contentClassName}>
          {loading ? this.renderLoadingState() : error ? this.renderErrorState() : this.renderActiveTab()}
        </section>
        {this.renderBottomNav()}
        {/* {!loading && !error ? (
          <AIAssistant
            parent={parent}
            students={students}
            studentDetails={studentDetails}
            activeTab={activeTab}
            isAuthenticated={isAuthenticated}
          />
        ) : null} */}
        <Login />
      </main>
    );
  }
}

export default Dashboard;
